import { useDominiosHuawei } from '@/shared/hooks/useDominiosHuawei';
import { PermissionsEnum } from "@/auth/interfaces";
import GetAppIcon from '@mui/icons-material/GetApp';
import {
  a11yProps,
  formatDateWithTimeAMPM,
  generateUUID,
  getEnvs,
  gridSizeMdLg12,
  gridSizeMdLg2,
  gridSizeMdLg5,
  gridSizeMdLg6,
  hasPermission,
  plantillaExcelENUM,
  useCheckPermissions,
} from "@/shared";
import {
  ButtonFileComponente,
  CustomAutocompleteNoForm,
  SampleTable,
  SingleIconButton,
  SingleTableBoxScene,
  SwitchComponente,
} from "@/shared/components/ui";
import { Button, Grid, Tab, Tabs } from "@mui/material";
import { MigracionRadius } from "../../shared/constants/migraciones-radius.interface";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { useCallback, useMemo, useState } from "react";
import { TableDataEditMigracionesRadius } from "../../shared/components/TableDataEditMigracionesRadius";
import { toast } from "react-toastify";
import { IBras } from "@/shared/interfaces/erp/configuracion-red/bras/bras.interface";
import { CeleryTaskMigracionBrasStatus, useFetchGetBras, useMigrarClientesBrasAsync } from "@/shared/actions/erp";
import { Ipv4 } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import axios from "axios";
import { saveAs } from "file-saver";
import { Info } from "@mui/icons-material";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { MRT_ColumnDef } from "material-react-table";
// import { useAuthStore } from "@/store/auth";
import { CustomTabPanel } from "@/erp/sale";
import MigracionesBrasProgressModal from "../../shared/components/MigracionesBrasProgressModal";

export type RadiusMigracionesPageProps = {};

const RadiusMigracionesPage: React.FC<RadiusMigracionesPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_migraciones_bras);
  const { VITE_API_URL_AWS, VITE_BUCKET_BASE } = getEnvs();

  // const user = useAuthStore(s => s.user);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [currentTaskId, setCurrentTaskId] = useState<string | null>(null);
  const [createdGroupName, setCreatedGroupName] = useState<string>('');
  const [itemsMigracionRadius, setItemsMigracionRadius] = useState<MigracionRadius[]>([]);
  const [editedItems, setEditedItems] = useState<Record<string, MigracionRadius>>({});
  const [tableKey, setTableKey] = useState(0);
  const [paramsIpv4, setParamsIpv4] = useState<Partial<Ipv4>&{bras?:string}>({});
  const [openModalEstado, setOpenModalEstado] = useState(false);
  const [detallesUltimaMigracion, setDetallesUltimaMigracion] = useState<any>({});
  const [verificarIpGrupoSwitch, setVerificarIpGrupoSwitch] = useState(false);
  // const [detallesMigracionSoftnet, setDetallesMigracionSoftnet] = useState<any>(null);
  const handleFileExcelCustom = useCargarSeriesProductos(s => s.handleFileExcelCustom)
  const setIsGlobalLoading = useUiStore((s) => s.setIsGlobalLoading);
  const [valueTab, setValueTab] = useState(0);

  // const { mutateAsync: mutateGenerarMigracionBras } = usePostGenerarMigracionBras();
  ///* mutations
  const { mutateAsync: mutateGenerarMigracionBras } = useMigrarClientesBrasAsync({
    onTaskStarted: (taskId, groupData) => {
      setCurrentTaskId(taskId);
      setCreatedGroupName(groupData?.nombre || 'Migracion a BRAS');
      setShowProgressModal(true);
    },
    onError: (error) => {
      toast.error(`Error al realizar la migración. ${error}`);
    },
  });

  /**
   * Opciones de Huawei-Domain-Name desde el parámetro del sistema
   * DOMINIOS_HUAWEI_RADIUS. Antes era una lista fija aquí, duplicada con la del
   * modal de rad-check: las dos podían desincronizarse.
   */
  const { dominios: dominiosHuawei } = useDominiosHuawei();
  const optionsValueRadreply = useMemo(
    () => dominiosHuawei.map((d) => ({ value: d, label: d })),
    [dominiosHuawei],
  );

  const downloadExcel = async (url: string, fileName: string) => {
    try {
      const response = await axios.get(url, {
        responseType: "blob", // Importante para obtener el archivo como un blob
      });
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, fileName);
    } catch (error) {
      console.error("Error al descargar el archivo Excel:", error);
    }
  };

  const {
    data: dataBras,
    isLoading: isLoadingBras
  } = useFetchGetBras({
    enabled:true,
    params:{
      estado:true
    }
  })

  // const { mutateAsync: mutateEstadoClienteBrasSoftnet } = usePostEstadoClienteBrasSoftnet();

  const columnsEstadoMigracionesRadius = useMemo<MRT_ColumnDef<any>[]>(
      () => [
          {
              accessorKey: 'pppoe',
              header: 'Usuario',
              size:100
          },
          {
              accessorKey: 'ip',
              header: 'IPV4',
              size:100
          },
          {
              accessorKey: 'error',
              header: 'Detalle',
              Cell: ({ row }) => !row.original?.error ? "Migrado Exitosamente" : row.original.error,
              size:600
          },
      ],
      [],
  );
  const columnsEstadoMigracionesSoftnet = useMemo<MRT_ColumnDef<any>[]>(
      () => [
          {
              accessorKey: 'id_instalacion_externa',
              header: 'Identificador',
              size:100
          },
          {
              accessorKey: 'pppoe',
              header: 'PPPoE',
              size:100
          },
          {
              accessorKey: 'detalle',
              header: 'Detalle',
              size:600
          },
      ],
      [],
  );


  const cargarValorParaTodos = async (valor: string) => {
      try{
          if(!optionsValueRadreply.find(option => option.value === valor)) {
              return toast.error('Valor no válido');
          }
          setIsGlobalLoading(true);
          
          const updatedData = itemsMigracionRadius.map((item) => ({
              ...item,
              value_radreply: valor
          }));

          setItemsMigracionRadius(updatedData);

          // Sincronizar editedItems también por si hay cambios pendientes
          const updatedEdited = Object.fromEntries(
              Object.entries(editedItems).map(([key, item]) => {
                  return [
                      key,
                      { ...item, value_radreply: valor }
                  ];
              })
          );
          setEditedItems(updatedEdited);
          setTableKey?.(prev => prev + 1);
          setIsGlobalLoading(false)

      }catch(error){
          console.error(error);
          toast.error('Error al cargar los valores');
      }finally{
          setIsGlobalLoading(false);
      }
  };
  if(!hasPermission(PermissionsEnum.api_migraciones_bras)) {
    return null;
  }
  // useEffect(() => {
  //   if (detallesMigracionSoftnet) {
  //     const newDetalles = detallesUltimaMigracion?.data?.map((item: any) => {
  //       const mensajeExistencia =
  //         detallesMigracionSoftnet.pppoe_en_eva?.includes(item?.pppoe)
  //           ? "PPPoE existe en EVA."
  //           : "PPPoE no existe en EVA.";

  //       return {
  //         ...item,
  //         error: item?.error
  //           ? `${item.error} - ${mensajeExistencia}`
  //           : mensajeExistencia
  //       };
  //     });

  //     setDetallesUltimaMigracion((prev: any) => ({
  //       ...prev,
  //       data: newDetalles
  //     }));
  //   }
  // }, [detallesMigracionSoftnet]);


  // Callback para cuando el proceso de creación termine
  const handleProgressComplete = useCallback((success: boolean, result?: CeleryTaskMigracionBrasStatus['result']) => {
    setShowProgressModal(false);
    setCurrentTaskId(null);

    if (success) {
      toast.success(
        result?.message || 'Migración BRAS completada correctamente',
      );
    } else {
      toast.error(
        result?.message || 'Error al realizar la migración BRAS',
      );
    }
  }, []);
  



  return (
    <SingleTableBoxScene
      title="Migraciones BRAS"
    >
          <Grid {...gridSizeMdLg12} container spacing={2}>
            <Grid item container {...gridSizeMdLg12} spacing={2}>
              <Grid container item {...gridSizeMdLg12} spacing={2}>
                <Grid container spacing={2} {...gridSizeMdLg6}>
                  <CustomAutocompleteNoForm<IBras>
                    label="BRAS Destino"
                    //name="label"
                    options={dataBras?.data?.data||[]}
                    valueKey={'nombre'}
                    actualValueKey={'codigo'}
                    defaultValue={''}
                    isLoadingData={isLoadingBras}
                    onChangeRawValue={async (value) => {
                      if(!value){
                        return
                      }
                      setParamsIpv4({
                        bras: value.codigo,
                        grupo_ipv4: value.grupo_ipv4
                      })
                      
                    }}
                    size={gridSizeMdLg12}
                    sxAutocomplete={{pr:1}}
                  />
                  <CustomAutocompleteNoForm
                      label="Definir los valores como..."
                      //name="label"
                      options={optionsValueRadreply}
                      valueKey={'label'}
                      actualValueKey={'value'}
                      defaultValue={''}
                      isLoadingData={false}
                      onChangeValue={(value) => {
                          cargarValorParaTodos(value);
                      }}
                      size={gridSizeMdLg6}
                  />
                  <Grid {...gridSizeMdLg6} container item alignContent={"center"}>
                    <SwitchComponente
                      estadoSwitch={verificarIpGrupoSwitch}
                      titulo={verificarIpGrupoSwitch ? 'Migración IPs Públicas':'Migración Normal'}
                      setEstadoSwitch={(val)=>{
                        setVerificarIpGrupoSwitch(val)
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid container {...gridSizeMdLg6} spacing={2} sx={{px:1}}>
                  <Grid item {...gridSizeMdLg5}>
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<GetAppIcon />}
                      style={{
                        color: 'black',
                        backgroundColor: 'white',
                        boxShadow: 'none',
                      }}
                      onClick={async()=>{
                        const url = `${VITE_API_URL_AWS}/${VITE_BUCKET_BASE}${plantillaExcelENUM.PLANTILLA_RADIUS_MIGRACION}`;
                        toast.info(
                          "En breve comenzará su descarga.",
                        );
                        try {
                          await downloadExcel(
                            url,
                            "plantilla-radius-migracion.xlsx"
                          );
                        } catch (error) {
                          toast.error("Lo sentimos ocurrio un error al descargar la plantilla");
                        }
                      }}
                    >
                      {'Descargar Formato'}
                    </Button>
                  </Grid>
                  <Grid item {...gridSizeMdLg5}>
                    <ButtonFileComponente
                      color={'success'}
                      accept={".xls, .xlsx"}
                      onChange={async (event) => {
                        try{
                          setIsGlobalLoading(true);
                          const dataJson = await handleFileExcelCustom(event, ["username","password","ipv4","valor"]);
                          const newItems: MigracionRadius[] = dataJson.map((item: any) => ({
                              id: generateUUID(),
                              pppoe: item.username,
                              password: item.password||"",
                              ip: item.ipv4 || '',
                              value_radreply: item.valor
                          }));

                          setItemsMigracionRadius(prev => [...prev, ...newItems]);
                          setTableKey(prev => prev + 1);
                        }catch{
                          toast.error('Error al procesar el archivo');
                        }finally{
                          setIsGlobalLoading(false);
                        }
                      }}
                      titulo={"Cargar Excel"} />
                  </Grid>
                  <Grid item {...gridSizeMdLg2}>
                    <SingleIconButton
                      startIcon={<Info />}
                      label={"Estado de migración"}
                      // disabled={!(detallesUltimaMigracion && Object.keys(detallesUltimaMigracion).length > 0 && detallesUltimaMigracion?.data?.length>0)}
                      onClick={() => {
                        setOpenModalEstado(true);
                      }}
                    />
                  </Grid>
                  <Grid item {...gridSizeMdLg12}>
                    <Button fullWidth variant="contained" color="info"
                    sx={{height:"100%"}}
                    onClick={async () => {
                      if (Object.keys(editedItems).length > 0) {
                        toast.error('Hay items sin guardar');
                        return;
                      }
                      if(itemsMigracionRadius.some(item => !item.pppoe || !item.value_radreply)){
                        toast.error('Hay items sin completar: PPPoE y Valor son obligatorios');
                        return;
                      }
                      if(!paramsIpv4.bras){
                        toast.error('Debe seleccionar un BRAS');
                        return;
                      }
                      setIsGlobalLoading(true);
                      await mutateGenerarMigracionBras({
                        bras: paramsIpv4.bras, 
                        datos_migracion:itemsMigracionRadius,
                        verifica_grupo_ip: verificarIpGrupoSwitch?false:true
                      },{
                        onSuccess: async () => {
                          setItemsMigracionRadius([]);
                          setEditedItems({});
                          setTableKey(prev=>prev+1)

                        },
                        onError: () => {
                          toast.error('Error al realizar la migración');
                        },
                        onSettled: () => {
                          setIsGlobalLoading(false);
                        }
                      })
                      // setDetallesUltimaMigracion({
                      //   ... await result,
                      //   fecha_migracion: new Date().toISOString()
                      // });
                    }} disabled={itemsMigracionRadius.length === 0}>
                      Realizar Migración
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item {...gridSizeMdLg12}>
                <TableDataEditMigracionesRadius<MigracionRadius>
                  data={itemsMigracionRadius}
                  setRowsData={setItemsMigracionRadius}
                  editedItems={editedItems}
                  setEditedItems={setEditedItems}
                  key={tableKey}
                  setTableKey={setTableKey}
                  paramsIpv4={paramsIpv4}
                  optionsValueRadreply={optionsValueRadreply}
                  // maxHeight="300px"
                />
              </Grid>
            </Grid>
          </Grid>

      <ScrollableDialogProps
        open={openModalEstado}
        title={`${detallesUltimaMigracion?.fecha_migracion ? 
          `Detalles de la Migración - ${formatDateWithTimeAMPM(detallesUltimaMigracion?.fecha_migracion)}` 
          : "Detalles de la Migración"}`
        }
        cancelTextBtn="Cerrar"
        confirmTextBtn="Exportar"
        // actions
        onClose={() => setOpenModalEstado(false)}
        onConfirm={()=>{
          switch(valueTab){
            case 0:
              detallesUltimaMigracion?.data_eva && downloadJsonAsExcel(detallesUltimaMigracion?.data_eva, `detalles-migracion-eva-${detallesUltimaMigracion?.fecha_migracion}`);
              break;
            case 1:
              detallesUltimaMigracion?.data_softnet?.statusCode === 200 && downloadJsonAsExcel(detallesUltimaMigracion?.data_softnet?.data, `detalles-migracion-softnet-${detallesUltimaMigracion?.fecha_migracion}`);
              break;
            default:
              break;
          }
          setOpenModalEstado(false)
        }}
        // content
        minWidth="60%"
        contentNode={
          <>
            <Tabs
              value={valueTab}
              onChange={(_event: React.SyntheticEvent, newValue: number) => {
                setValueTab(newValue);
              }}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              aria-label="scrollable-tabs-radius-migraciones"
            >
              <Tab label={"Estado Migración EVA"} {...a11yProps(0)} />
              <Tab label={"Estado Migración Softnet"}{...a11yProps(1)} />
            </Tabs>
            <CustomTabPanel value={valueTab} index={0}>
                <Grid container {...gridSizeMdLg12} spacing={3}>
                  <Grid item container {...gridSizeMdLg12} width={"100%"}>
                    <SampleTable<any>
                      columns={columnsEstadoMigracionesRadius as any}
                      data={detallesUltimaMigracion?.data_eva || []}
                    />
                  </Grid>
                </Grid>
            </CustomTabPanel>
            <CustomTabPanel value={valueTab} index={1}>
                <Grid container {...gridSizeMdLg12} spacing={3}>
                  <Grid item container {...gridSizeMdLg12} width={"100%"}>
                    <SampleTable<any>
                      columns={columnsEstadoMigracionesSoftnet as any}
                      data={detallesUltimaMigracion?.data_softnet?.data || []}
                    />
                  </Grid>
                </Grid>
            </CustomTabPanel>
          </>
        }
      />
      {/* Modal de progreso de Migración de Bras */}
      <MigracionesBrasProgressModal
        open={showProgressModal}
        taskId={currentTaskId}
        onComplete={handleProgressComplete}
        groupName={createdGroupName}
        setDetallesMigracion={setDetallesUltimaMigracion}
      />
      
    </SingleTableBoxScene>
  );
};

export default RadiusMigracionesPage;



export function downloadJsonAsExcel(data: object[], fileName: string = 'archivo') {
  // 1. Convertir JSON a hoja
  const worksheet = XLSX.utils.json_to_sheet(data);

  // 2. Crear libro y agregar la hoja
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Hoja1');

  // 3. Descargar
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
}